import React from 'react';
import { Button } from "@material-ui/core";
import { reactGaEvent } from "examsbook-react-sdk/actions/Common";
import { useNavigate } from "react-router-dom";

/**
 * TestSeriesCardButtonGroup
 * @param props
 * @returns {*}
 * @constructor
 */
const TestSeriesCardButtonGroup = props => {
    const { testData, t } = props;
    const navigate = useNavigate();

    function handleGoToTestClick() {
        reactGaEvent("Test Series", "Go To Test");
        navigate('/my-app/test-series/' + testData._id + '/tests');
    }

    return (
        <div className="hideInMobile">
            <div className="card-btn">
                <div className="date-time test-date-time">
                    {t('expires_on')}:
                    <span>{testData.endDate}</span>
                </div>
                <Button disabled={!testData.totalTest} onClick={handleGoToTestClick}>
                    {t('go_to_test')}
                </Button>
            </div>
        </div>
    );
};

export default TestSeriesCardButtonGroup;
